import {
  ClikDataCategory,
  ClikDataStatus,
  ClikEnquiryType,
  GetClikDataListQuery,
  GetClikDataQuery,
} from "../../graphql/generated.ts";
import { toHumanReadable } from "../../utils/string.ts";

export type ClikData = GetClikDataListQuery["clikDataList"]["data"][0];
export type ClikDataDetail = GetClikDataQuery["clikData"];

export const enquiryTypeOptions = Object.values([
  ClikEnquiryType.Company,
  ClikEnquiryType.Individual,
]).map((item) => ({
  value: item,
  label: toHumanReadable(item),
}));

export const toHumanReadableStatus = (status: ClikDataStatus) => {
  switch (status) {
    case ClikDataStatus.Active:
      return "Success";
    default:
      return toHumanReadable(status);
  }
};

export const categoryOptions = Object.values(ClikDataCategory).map((value) => {
  return { value, label: toHumanReadable(value) };
});
